<script>
import { usePageStore } from '@voix/store/pageStore'

export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    slice: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  mounted() {
    defineSlice({
      name: {
        label: 'Introduction Two Column',
        group: 'Hyatt',
        layouts: ['HyattZilara', 'HyattZiva'],
      },
      preview: 'SlicesHyattIntroductionTwoColumn.jpg',
      tags: ['Columns', 'Wysiwyg'],
      description: 'Huge scripty title with an introduction and a background graphic from a list of selectable SVGs',
      fields: {
        title: {
          type: 'text',
          label: 'Title',
          group: 'Title',
        },
        titleTag: {
          group: 'Title',
          type: 'select',
          label: 'Title Tag',
          options: { h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6' },
          default: 'h1',
        },
        titleSize: {
          type: 'select',
          label: 'Title Size',
          group: 'Title',
          options: {
            'text-sm': 'Small',
            'text-base': 'Base',
            'text-lg': 'Large',
            'text-xl': 'XL',
            'text-2xl': '2XL',
            'text-3xl': '3XL',
            'text-4xl': '4XL',
            'text-5xl': '5XL',
            'text-6xl': '6XL',
            'text-7xl': '7XL',
            'text-8xl': '8XL',
          },
          default: 'text-8xl',
        },
        subtitle: { type: 'text', label: 'Sub-Title', group: 'Sub-Title Top' },
        subtitleTag: {
          group: 'Sub-Title Top',
          type: 'select',
          label: 'Subtitle Tag',
          options: {
            h1: 'h1',
            h2: 'h2',
            h3: 'h3',
            h4: 'h4',
            h5: 'h5',
            h6: 'h6',
          },
          default: 'h2',
        },
        subtitleSize: {
          type: 'select',
          label: 'Subtitle Size',
          group: 'Sub-Title Top',
          options: {
            'text-sm': 'Small',
            'text-base': 'Base',
            'text-lg': 'Large',
            'text-xl': 'XL',
            'text-2xl': '2XL',
            'text-3xl': '3XL',
            'text-4xl': '4XL',
            'text-5xl': '5XL',
          },
          default: 'text-base',
        },
        subtitleMargin: {
          type: 'number',
          label: 'Top Margin',
          group: 'Sub-Title Top',
          default: 0.5,
        },
        subtitle2: { type: 'text', label: 'Sub-Title', group: 'Sub-Title Bottom' },
        subtitle2Tag: {
          group: 'Sub-Title Bottom',
          type: 'select',
          label: 'Subtitle Tag',
          options: {
            h1: 'h1',
            h2: 'h2',
            h3: 'h3',
            h4: 'h4',
            h5: 'h5',
            h6: 'h6',
          },
          default: 'h2',
        },
        subtitle2Size: {
          type: 'select',
          label: 'Subtitle Size',
          group: 'Sub-Title Bottom',
          options: {
            'text-sm': 'Small',
            'text-base': 'Base',
            'text-lg': 'Large',
            'text-xl': 'XL',
            'text-2xl': '2XL',
            'text-3xl': '3XL',
            'text-4xl': '4XL',
            'text-5xl': '5XL',
          },
          default: 'text-base',
        },
        subtitle2Margin: {
          type: 'number',
          label: 'Bottom Margin',
          group: 'Sub-Title Bottom',
          default: 1,
        },
        introduction: { type: 'wysiwyg', label: 'Introduction' },
      },
      templates: [
        {
          label: 'Introduction Two Column',
          fields: {
            bgsvg: { value: 'spiral-coral-web' },
            introduction: {
              value:
                '<div>Situated on the widest stretch of beach in Cancun in the heart of the famous Hotel Zone, Hyatt Zilara Cancun welcomes you to an adults-only oasis of all-inclusive, oceanfront luxury.&nbsp;<\/div>',
            },
            subtitle: {
              value: '<p><strong>All-Inclusive<br>Exclusively for Adults<\/strong><\/p>',
            },
            title: { value: '<div>Luxury<\/div>' },
          },
        },
      ],
    })
  },
}
</script>

<template>
  <div
    class="pt-10 md:pt-16 pb-10 px-0 2xl:px-48 md:container flex flex-col xl:flex-row justify-between items-center"
  >
    <div class="flex flex-col w-full text-center xl:text-left">
      <!-- Subtitle Top -->
      <div
        v-if="fields.subtitle.value"
        class="relative z-10 xl:ml-36"
        :style="{ top: `${fields.subtitleMargin.value}rem` }"
        v-html="`<${fields.subtitleTag.value} class='text-6xl md:${fields.subtitleSize.value} font-thin'> ${fields.subtitle.value} </${fields.subtitleTag.value}>`"
      />

      <!-- Title -->
      <div
        class="main-title title xl:mx-14 xl:min-w-[400px]"
        v-html="`<${fields.titleTag.value} class='text-6xl md:${fields.titleSize.value}'> ${fields.title.value} </${fields.titleTag.value}>`"
      />

      <!-- Subtitle -->
      <div
        v-if="fields.subtitle2.value"
        class="relative z-10 xl:ml-36"
        :style="{ bottom: `${fields.subtitle2Margin.value}rem` }"
        v-html="`<${fields.subtitle2Tag.value} class='text-6xl md:${fields.subtitle2Size.value} font-thin'> ${fields.subtitle2.value} </${fields.subtitle2Tag.value}>`"
      />
    </div>

    <div
      class="wysiwyg mt-4 xl:mt-0 px-8 text-center xl:text-left leading-loose"
      v-html="fields.introduction.value"
    />
  </div>
</template>

<style>
.hyatt-ziva-theme,
.hyatt-zilara-theme {
  .main-title h1,
  .main-title h2,
  .main-title h3,
  .main-title h4 {
    @apply font-cursive;
  }
}
.hyatt-dreams-theme,
.hyatt-vivid-theme,
.hyatt-secrete-theme {
  .main-title h1,
  .main-title h2,
  .main-title h3,
  .main-title h4 {
    @apply  text-zilara-cancun-grey;
  }
}
</style>
